
<template>
  <hidden :class="`${is_expanded && 'is-expanded'} burger-menu`">
    <div class="flex" />
    <div class="menu-hamburger">
      <div class="logo">
        <img src="../../public/logo.png"
             alt="Vue"
        >
        <span class="logotext">Brandsäkra {{ chosenCustomer.Name ? '('+chosenCustomer.Name+')': '' }}</span>
        <button class="menu-toggle"
                @click="ToggleMenu"
        >
          <span class="material-icons-round hamburger-menu">menu</span>
        </button>
      </div>
            
      <div v-if="is_expanded">
        <RouterButtons />
      </div>
    </div>
  </hidden>
  <aside :class="`${is_expanded && 'is-expanded'}`">
    <div class="logo">
      <img src="../../public/logo.png"
           alt="Vue"
      >
      <div>
        <span class="logotext">Brandsäkra</span>
        <span class="customerText">{{ chosenCustomer.Name }}</span>
      </div>
    </div>
    <div class="menu-toggle-wrap">
      <button class="menu-toggle"
              @click="ToggleMenu"
      >
        <span class="material-icons-round">keyboard_double_arrow_right</span>
      </button>
    </div>
    <RouterButtons />
  </aside>
</template>

<script setup>

import { onMounted, computed} from 'vue';
import { useStore } from 'vuex';
import RouterButtons from '../components/RouterButtons.vue';
const store = useStore()

//const isAuthenticated = computed(() => store.state.sidebar.isAuthenticated)
const is_expanded = computed(() => store.state.sidebar.isExpanded)
const chosenCustomer = computed(() => store.state.account.chosenCustomer)

    
onMounted(async() => {
    if(localStorage.getItem("token")){
        store.commit('sidebar/setAuth'); //Already logged in, make sure we set state to logged in.
    }
})

function ToggleMenu() {
    store.commit('sidebar/toggleIsExpanded');
}
</script>

<style lang="scss" scoped>
    .hamburger-menu{
        font-size: 2rem !important;
    }
hidden {

    transition: 0.2s ease-out;
    display: block;
    top:0px;
    position: absolute;
    height: calc(4rem);
    min-width: 100%;
    padding: 1rem;

    z-index: 195;
    background-color: var(--sidebar);
    color: var(--light);

    transition: 0.2s ease-out;

    .flex {
        flex: 1 1 0;
    }
    .logotext{
        display: none;
    }
    &.is-expanded {
        .logotext{
            display: inline;
            margin-left: 23px;
            top: 25px;
            position: fixed;
            font-size: 21px;
        }
        height: calc(18rem);

        .menu-hamburger {
        display: block;
        justify-content: center;
        }
        .menu-toggle {
        display: flex;
        justify-content: flex-end;
        }
        .logo{
            border-bottom: 2px solid black;
        }
        
     }
     .logo{
        height: 60px;
        img{
            width:19px;
                display: flex;
                justify-content: flex-start;
                /* margin: 10px; */
                /* float: left; */
                position: fixed;
                left: 14px;
        }
    }
    .menu-hamburger {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 0rem;

        position: relative;
        top: 0;
        transition: 0.2s ease-out;
        opacity: 1;
        .menu-toggle {
            transition: 0.2s ease-out;
            margin: auto;
            margin-right: 0;
            margin-top: 0px;
            .material-icons-round {
                font-size: 1rem;
                color: var(--light);
            }

            &:hover {
                .material-icons-round {
                    font-size: 1rem;
                    transition: 0.2s ease-out;
                }
            }
        }
        
    }
    
    @media(min-width:769px) {
            
            transition: 0.2s ease-out;
            top:-100px;
            position: fixed;
            z-index: 95;
            display: none;
    }

}

aside {
     @media(max-width:768px) {
            display: none;
    }
    display: flex;
    flex-direction: column;
    width: calc(2rem + 32px);
    overflow: hidden;
    min-height: 100vh;
    padding: 1rem 1rem 0rem 1rem;
    left:0px;
    background-color: var(--sidebar);
    color: var(--light);

    z-index: 200;
    transition: 0.2s ease-out;
    .customerText{ 
        display: none; 
    }
    .flex {
        flex: 1 1 0;
    }
    .versionText{
        margin-left: 4px;
        font-size: 11px;
    }
    .logo {
        margin-bottom: 1rem;
        display: flex;
        height: 55px;
        img {
            max-width: 2rem;
            max-height: 55px;
            transition: 0.2s ease-out;
        }
        .logotext{
            opacity: 0;
            padding-left: 10px;
            padding-top: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 30px;
            font-weight: bold;
        }
    }

    
    .menu-toggle-wrap {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 0rem;

        position: relative;
        top: 0;
        transition: 0.2s ease-out;

        .menu-toggle {
            transition: 0.2s ease-out;

            .material-icons-round {
                font-size: 2rem;
                color: var(--light);
            }

            &:hover {
                .material-icons-round {
                    font-size: 2rem;
                    color: var(--dark);
                    transition: 0.2s ease-out;
                }
            }
        }
    }

    h3,
    .button .text {
        opacity: 0;
        transition: 0.3s ease-out;
    }
    .textButton {
        opacity: 0;
        transition: 0.3s ease-out;
    }

    .menu {
                
        background-color: var(--sidebar);
        margin: 0 -1rem;
        z-index: 1;
        .button {
            width: 100%;
            display: flex;
            align-items: center;
            text-decoration: none;
            padding: 0.4rem 1rem;
            transition: 0.2s ease-out;
            
            .material-icons-round {
                font-size: 1rem;
                color: var(--light);
                transition: 0.2s ease-out;
            }

            .text {
                color: var(--light);
                transition: 0.2s ease-out;
                line-height: 0px;
            }
            .textButton {
                font-size: 1rem;
                color: var(--light);
                transition: 0.2s ease-out;
            }

            &:hover,
            &.router-link-exact-active {
                background-color: var(--sidebardark);

                .material-icons,
                .text {
                    color: var(--selected);
                }
                .textButton {
                    color: var(--selected);
                }
            }

            &.router-link-exact-active {
                border-right: 5px solid var(--selected);
                border-radius: 3px;
            }

        }
    }

    
    

    &.is-expanded {
        width: var(--sidebar-width);
        
        transition: 0.2s ease-out;
        .menu-toggle-wrap {
            
            .menu-toggle {
                transform: rotate(-180deg);
            }
        }

        h3,
        .button .text {
            opacity: 1;
        }

        .textButton {
            opacity: 1;
        }

        .button {
            .material-icons-round {
                margin-right: 1rem;
            }
        }

        .logo {
            margin-bottom: 1rem;

            img {
                transition: 0.2s ease-out;
            }
            .logotext{
                transition: 0.2s ease-out;
                opacity: 1;
            }
        }
        .customerText{ 
            opacity: 1; 
            padding-left: 10px; 
            padding-top: 10px; 
            display: flex; 
            align-items: center; 
            justify-content: center; 
            font-size: 14px; 
            font-weight: bold; 
        } 
    }
    
    &.is-hidden{

        left:0px;
        transition: 0.4s ease-out;

        @media(max-width:768px) {
            transition: 0.4s ease-out;
            position: fixed;
            z-index: 99;
            left:-250px;
            display: none;
            
        }
    }

    @media(max-width:768px) {
            transition: 0.4s ease-out;
            position: fixed;
            z-index: 99;
            left:0px;
        }

}


</style>